import React from 'react';

import ProfileDisplay from './components/ProfileDisplay';
import ProfileEdit from './components/ProfileEdit';
import store from '../../../stores/store';

import './components/profile.css';
import './components/iOS-switch.css';

class ProfileView extends React.Component {
    render() {
        store.user.fetch();

        // This is setup when they click edit
        if (store.user.editProfile === 0) {
            return (
                <div
                    className="p-0 mt-md-3 mb-3 d-flex justify-content-center animated fadeIn"
                    id="user-profile"
                >
                    <div className="card profile-data-width">
                        <ProfileDisplay history={this.props.history} />
                    </div>
                </div>
            );
        } else {
            return (
                <div
                    className="p-0 mt-md-3 mb-3 d-flex justify-content-center animated fadeIn"
                    id="user-profile"
                >
                    <div className="card profile-data-width">
                        <ProfileEdit history={this.props.history} />
                    </div>
                </div>
            );
        }
    }
}
export default ProfileView;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Profile/ProfileView.js